import { LineDelveTypes } from "../actions/index.model";
import { LineDeleveDetails, MyLineDelve, userEmails } from "./index.model";
import { Lines } from "../../LineDetails/reducers/index.model";

const lineDelveDetails: LineDeleveDetails = {
  user: {
    IAMEmail: "",
    userid: "",
  },
  lines: [],
  userEmails: [],
};
const defaultState: MyLineDelve = {
  lineDelveDetails: lineDelveDetails,
  pairedLine: [],
  deviceList: [],
  primaryDevice: [],
  noOfAttempts: 0,
  loading: false,
  error: "",
  lineDelveDetailsMain: lineDelveDetails,
};

const filterLineDelvedetails = (response: LineDeleveDetails, key: string) => {
  let result: LineDeleveDetails = { ...response };
  result.userEmails = result.userEmails.filter((obj: userEmails) => {
    if (obj.granteeEmail.toLowerCase().indexOf(key) !== -1) {
      return obj;
    }
    return false;
  });
  return { linesDelveDetails: result };
};

const implicitUser = (implicitUserArray: any, currentUser: string) => {
  return implicitUserArray.some(
    (obj: any) => obj.user.IAMEmail === currentUser
  );
};

const isLineRemovable = (
  currentUser: string,
  grantor: string,
  grantee: string,
  msisdn: string,
  implicitArray: any
) => {
  var isRemovable = false;
  const implicitUserData = implicitArray.filter((user: any) => {
    return user.user.IAMEmail === currentUser;
  });
  var implicitLine =
    implicitUserData.length > 0
      ? implicitUserData[0].lines.filter(
          (obj: Lines) =>
            obj.msisdn === msisdn && obj.isLineGrantable === "true"
        )
      : [];
  const isLineGrantable = implicitLine.length
    ? implicitLine[0].isLineGrantable
    : false;
  if (
    (grantor === currentUser &&
    grantee === currentUser &&
    implicitUser(implicitArray, currentUser))||
    (grantor === currentUser &&
    grantee !== currentUser &&
    implicitUser(implicitArray, currentUser) &&
    isLineGrantable === "true") ||
    ( grantor !== currentUser &&
    grantee === currentUser &&
    implicitUser(implicitArray, currentUser))||
    (grantor !== currentUser &&
    grantee !== currentUser &&
    implicitUser(implicitArray, currentUser) &&
    isLineGrantable === "true") ||
    ( grantor !== currentUser &&
    grantee === currentUser &&
    !implicitUser(implicitArray, currentUser))
  ) {
    isRemovable = true;
  }
  //  else if (
  //   grantor === currentUser &&
  //   grantee !== currentUser &&
  //   implicitUser(implicitArray, currentUser) &&
  //   isLineGrantable === "true"
  // ) {
  //   isRemovable = true;
  // } else if (
  //   grantor !== currentUser &&
  //   grantee === currentUser &&
  //   implicitUser(implicitArray, currentUser)
  // ) {
  //   isRemovable = true;
  // } else if (
  //   grantor !== currentUser &&
  //   grantee !== currentUser &&
  //   implicitUser(implicitArray, currentUser) &&
  //   isLineGrantable === "true"
  // ) {
  //   isRemovable = true;
  // } else if (
  //   grantor !== currentUser &&
  //   grantee === currentUser &&
  //   !implicitUser(implicitArray, currentUser)
  // ) {
  //   isRemovable = true;
  // }
  // else if (
  //   grantor === currentUser &&
  //   grantee === currentUser &&
  //   !implicitUser(implicitArray, currentUser)
  // ) {
  //   isRemovable = false;
  // } else if (
  //   grantor === currentUser &&
  //   grantee !== currentUser &&
  //   !implicitUser(implicitArray, currentUser)
  // ) {
  //   isRemovable = false;
  // } 
  
  //  else if (
  //   grantor !== currentUser &&
  //   grantee !== currentUser &&
  //   !implicitUser(implicitArray, currentUser)
  // ) {
  //   isRemovable = false;
  // }
  return isRemovable;
};

const getUserEmails=(explicitPermissions:any,implicitPermissions:any,IAMEmail:any)=>{
  let userEmails: any = [];
  if (explicitPermissions) {
    userEmails = explicitPermissions
      .map((flterObj: any) => {
        return {
          grantor: flterObj.grantor,
          grantorEmail: flterObj.grantorEmail,
          granteeEmail: flterObj.granteeEmail,
          msisdn: flterObj.msisdn,
          grantee: flterObj.grantee,
          isRemovable: implicitPermissions? isLineRemovable(
            IAMEmail,
            flterObj.grantorEmail,
            flterObj.granteeEmail,
            flterObj.msisdn,
            implicitPermissions
          ):false,
        };
      })
      .sort((val1: any, val2: any) =>
        val1.granteeEmail.toLowerCase() >
        val2.granteeEmail.toLowerCase()
          ? 1
          : -1
      );
  }
  return userEmails
}

const getImplicitUserDetailes=(implicitPermissions:any,userId:string,IAMEmail:any)=>{
  const implicitUserDetails: any = [];
  if (implicitPermissions && implicitPermissions.length > 0) {
    implicitPermissions.forEach((item: any) => {
      item.lines.forEach((lineObj: any) => {
        if (lineObj.permissionType === "linked") {
          implicitUserDetails.unshift({
            grantor: userId,
            grantorEmail: IAMEmail,
            granteeEmail: item.user.IAMEmail,
            msisdn: lineObj.msisdn,
            grantee: "userid:" + item.user.userid,
            isRemovable: false,
          });
        }
      });
    });
  }
  return implicitUserDetails;
}

const sortUserEmails=(userEmails:any)=>{
  return userEmails.sort((val1: any, val2: any) =>
    val1.granteeEmail.toLowerCase() > val2.granteeEmail.toLowerCase()
      ? 1
      : -1
  )
}

const getLinesDelveData=(action:any,lineDelveDetails:any)=>{
  //debugger
  let deleveDetails: LineDeleveDetails = {} as LineDeleveDetails;
      if (action.data === null || action.data.length === 0) {
        deleveDetails = lineDelveDetails;
      } else {
        var details = { ...action.data.res };
        // if (
        //   details.implicitPermissions &&
        //   details.implicitPermissions.length > 0
        // ) {
          const implicitPermissions = details.implicitPermissions;
          const explicitPermissions = details.explicitPermissions;
          const IAMEmail = action.data.grantorEmail;
          const userDetails = implicitPermissions?.find(
            (item: any) => item.user.IAMEmail === IAMEmail
          );

          const userId = "userid:" + userDetails?.user.userid;
          let userEmails: any = getUserEmails(explicitPermissions,implicitPermissions,IAMEmail);
   

          const implicitUserDetails: any = getImplicitUserDetailes(implicitPermissions,userId,IAMEmail);
        
          deleveDetails.user = details.implicitPermissions?details.implicitPermissions[0].user:null;
          deleveDetails.lines = details.implicitPermissions?details.implicitPermissions[0].lines:[];

          //  //UD-3171
          //let tempUserEmails = [...implicitUserDetails,...userEmails];

          let tempUserEmails = [...implicitUserDetails];
          userEmails.forEach((exp_user: any) => {
            // var implicitUser = implicitUserDetails.filter((imp_user: any) => {
            //   return imp_user.granteeEmail === exp_user.granteeEmail;
            // });
            //if (implicitUser.length === 0) {
              tempUserEmails.push(exp_user);
            //}
          });

          tempUserEmails = sortUserEmails(tempUserEmails);
          const emailIndex = tempUserEmails.findIndex(
            (obj: any) => obj.granteeEmail === IAMEmail
          );
          if (tempUserEmails.length > 0 && emailIndex > -1) {
            tempUserEmails.unshift(tempUserEmails.splice(emailIndex, 1)[0]);
          }
          deleveDetails.userEmails = [...tempUserEmails];
        //}
      }
      return deleveDetails;
}

const LineDelveReducer = (state: MyLineDelve = defaultState, action: any) => {
  switch (action.type) {
    case LineDelveTypes.GET_LINE_DELVE_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case LineDelveTypes.RESET_LINE_DELVE_DETAILS:
      return {
        ...defaultState,
      };
    case LineDelveTypes.SET_PAIRED_LINE:
      return {
        ...state,
        pairedLine: action.data,
      };
    case LineDelveTypes.FILTER_LINE_DELVE_DETAILS:
      const data = filterLineDelvedetails(
        state.lineDelveDetailsMain,
        action.data
      );
      return {
        ...state,
        lineDelveDetails: data?.linesDelveDetails,
        error: "",
      };
    case LineDelveTypes.SET_PRIMARY_DEVICE:
      return {
        ...state,
        primaryDevice: action.data,
      };
    case LineDelveTypes.RESET_ATTEMPTS:
      return {
        ...state,
        noOfAttempts: 0,
      };
    case LineDelveTypes.REMOVE_GRANTEE_FAIL:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case LineDelveTypes.SET_DEVICE_LIST:
      return {
        ...state,
        deviceList: action.data,
      };
    case LineDelveTypes.UPDATE_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case LineDelveTypes.REMOVE_GRANTEE_SUCCESS:
      return {
        ...state,
        loading: false,
        noOfAttempts: 0,
        error: "",
      };

    case LineDelveTypes.SET_LINE_DELVE_DETAILS:
      const deleveDetails: LineDeleveDetails = getLinesDelveData(action,lineDelveDetails);
      
      return {
        ...state,
        lineDelveDetails: { ...deleveDetails },
        lineDelveDetailsMain: { ...deleveDetails },
        loading: false,
      };
    case LineDelveTypes.SUCCESS_DEACTIVATE_LINE:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case LineDelveTypes.ERROR_DEACTIVATE_LINE:
      return {
        ...state,
        loading: false,
        error: "error",
      };
    default:
      return state;
  }
};

export default LineDelveReducer;
